import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { MemberCollection } from '../index'

export const setupMemberReplication = (
  collection: MemberCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'members',
    displayName: 'Member',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      userId: doc.userId,
      isDefault: doc.isDefault || false,
      email: doc.email,
      name: doc.name,
      profilePictureUrl: doc.profilePictureUrl,
      role: doc.role ?? 'member',
      isSuperAgent: doc.isSuperAgent ?? false,
      lastActiveAt: doc.lastActiveAt
        ? (toTimestamp(doc.lastActiveAt) ?? new Date(doc.lastActiveAt).getTime())
        : null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      userId: state.userId,
      isDefault: state.isDefault,
      email: state.email,
      name: state.name,
      profilePictureUrl: state.profilePictureUrl,
      role: state.role ?? 'member',
      // isSuperAgent is server-authoritative (set on onboarding) — echo it back so the
      // push handler can ignore it without field mismatch.
      isSuperAgent: state.isSuperAgent ?? false,
      // lastActiveAt is server-owned (stamped on auth) — echo back what we received
      // so the server's push handler can ignore it without field mismatch.
      lastActiveAt: toISOStringOrNull(state.lastActiveAt ?? null),
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
